import * as React from 'react';

import { cn } from '@/lib/cn';

export const FIELD_CLASS =
  'w-full rounded-control border border-line-strong bg-surface text-sm text-ink outline-none transition-colors placeholder:text-ink-3 ' +
  'hover:border-ink-3 focus-visible:border-brand focus-visible:ring-2 focus-visible:ring-brand/40 ' +
  'disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-danger aria-invalid:focus-visible:ring-danger/40';

export type InputSize = 'sm' | 'md' | 'lg';

const INPUT_HEIGHT: Record<InputSize, string> = { sm: 'h-8', md: 'h-9', lg: 'h-12 text-base' };

export function Input({
  className,
  size = 'md',
  ...props
}: Omit<React.ComponentProps<'input'>, 'size'> & {
  /** `sm` 32, `md` 36, `lg` 48 (phone forms, next to a `lg` button). */
  size?: InputSize;
}) {
  return <input data-slot="input" data-size={size} className={cn(FIELD_CLASS, 'px-3', INPUT_HEIGHT[size], className)} {...props} />;
}
